import * as React from "react";
import type { SVGProps } from "react";
const SvgMountainsWithArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.616 16.926A1 1 0 0 0 12 17a1 1 0 0 0 .71-.29l2.5-2.5a1.004 1.004 0 1 0-1.42-1.42l-.79.794V10a1 1 0 1 0-2 0v3.584l-.79-.794a1.004 1.004 0 1 0-1.42 1.42l2.5 2.5a1 1 0 0 0 .326.216"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 20h18a1 1 0 0 0 .83-.44 1 1 0 0 0 .09-.94L15.65 3.5a2.36 2.36 0 0 0-2.1-1.5 2.42 2.42 0 0 0-2.13 1.46L10.2 6a2.2 2.2 0 0 0-1.46-.53A2.38 2.38 0 0 0 6.69 7L2.07 18.63A1 1 0 0 0 3 20m16.47-2h-15L8.49 7.78c.1-.22.25-.3.31-.31s.19.09.27.24l.38.68a1 1 0 0 0 1.419.364 1 1 0 0 0 .361-.404l2-4.07c.08-.17.19-.28.29-.28.08 0 .21.08.3.28z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMountainsWithArrowDown;
